import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  addVendorType,
  getVendorTypes,
  updateVendorType,
  deleteVendorType,
} from "./vendorTypeMasterAPI";

const initialState = {
  loading: false,
  vendorTypeList: [],
  pagination: {},
};

const actions = {
  CREATE_VENDOR_TYPE: "vendorTypeMaster/CREATE_VENDOR_TYPE",
  GET_VENDOR_TYPES: "vendorTypeMaster/GET_VENDOR_TYPES",
  UPDATE_VENDOR_TYPE: "vendorTypeMaster/UPDATE_VENDOR_TYPE",
  DELETE_VENDOR_TYPE: "vendorTypeMaster/DELETE_VENDOR_TYPE",
};

export const createVendorTypeThunk = createAsyncThunk(
  actions.CREATE_VENDOR_TYPE,
  async (payload) => {
    const response = await addVendorType(payload);
    return response;
  }
);

export const getVendorTypesThunk = createAsyncThunk(
  actions.GET_VENDOR_TYPES,
  async (payload) => {
    const response = await getVendorTypes(
      payload?.page,
      payload?.per_page,
      payload?.search
    );
    return response;
  }
);

export const updateVendorTypeThunk = createAsyncThunk(
  actions.UPDATE_VENDOR_TYPE,
  async ({ id, ...payload }) => {
    const response = await updateVendorType(id, payload);
    return response;
  }
);

export const deleteVendorTypeThunk = createAsyncThunk(
  actions.DELETE_VENDOR_TYPE,
  async (id) => {
    const response = await deleteVendorType(id);
    return response;
  }
);

export const vendorTypeMasterSlice = createSlice({
  name: "vendorTypeMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createVendorTypeThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(createVendorTypeThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Vendor Type created successfully!");
        } else {
          message.error(msg || "Failed to create Vendor Type.");
        }
      })
      .addCase(createVendorTypeThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to create Vendor Type.");
      });

    builder
      .addCase(getVendorTypesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVendorTypesThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, data } = action.payload;
        if (success) {
          state.vendorTypeList = data?.data || [];
          state.pagination = data?.pagination || {};
        } else {
          message.error(msg || "Failed to fetch Vendor Types.");
        }
      })
      .addCase(getVendorTypesThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to fetch Vendor Types.");
      });

    builder
      .addCase(updateVendorTypeThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVendorTypeThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Vendor Type updated successfully!");
        } else {
          message.error(msg || "Failed to update Vendor Type.");
        }
      })
      .addCase(updateVendorTypeThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to update Vendor Type.");
      });

    builder
      .addCase(deleteVendorTypeThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteVendorTypeThunk.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg } = action.payload;
        if (success) {
          message.success(msg || "Vendor Type deleted successfully!");
        } else {
          message.error(msg || "Failed to delete Vendor Type.");
        }
      })
      .addCase(deleteVendorTypeThunk.rejected, (state, action) => {
        state.loading = false;
        message.error(action.error.message || "Failed to delete Vendor Type.");
      });
  },
});

export default vendorTypeMasterSlice.reducer;
